var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "700 300 1300 1300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1205 1526 c-129 -37 -245 -110 -321 -203 -270 -332 -144 -816 254 -977 73 -29 84 -31 217 -31 121 0 149 3 207 23 300 104 477 430 398 736 -51 201 -202 369 -393 436 -80 29 -285 37 -362 16z m264 -131 c88 -21 156 -60 175 -100 63 -131 -62 -459 -254 -668 -98 -107 -185 -150 -254 -127 -49 16 -158 119 -195 183 -85 151 -82 355 8 496 114 177 320 263 520 216z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebex);
export default __webpack_public_path__ + "static/media/webex.dab5e3d1.svg";
export { ForwardRef as ReactComponent };